import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsNewUsersFunnel} from '../../../../../actions/entities/statistics/newUsersFunnel';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import DateRangePickerWrapper from '../../../../../components/DatePicker/DateRangePickerWrapper';
import Loader from '../../../../../components/Loader';
import './index.css';

class NewUsersFunnelWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {end, start, lang: 'ALL'};
  }

  fetchStats() {
    const {end, start} = this.state;
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsNewUsersFunnel(
          {
            endDate: moment(end).format('YYYY-MM-DD'),
            startDate: moment(start).format('YYYY-MM-DD'),
          },
          null,
          (type, error) =>
            swal({
              title: `Oops...`,
              type: 'error',
              html:
                `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                `<pre><code>${JSON.stringify(
                  error,
                  undefined,
                  4,
                )}</code></pre>`,
            }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  renderPie(dimensions, backgroundColor, value, type, percentage) {
    return (
      <div style={{position: 'relative'}}>
        <div
          style={{
            color: type === 'Subscribers' && '#3ccb3b',
            backgroundColor,
            width: dimensions,
            height: dimensions,
          }}
          className="pie">
          {percentage}%
        </div>
        <div className="pieValue">{value.toLocaleString()}</div>
        <div className="pieName">{type}</div>
      </div>
    );
  }

  calculateDecrease(before, after) {
    return Math.round(((after - before) / before) * 100);
  }

  renderTable() {
    const {data} = this.props;
    if (!data) return false;
    const {lang} = this.state;
    const {
      creators,
      joiners,
      newUsers,
      usersWhoWentLive,
      usersWhoWentMercato,
      usersWhoWentPaidLive,
    } = data.countries[lang];
    const maxWidth = 300;
    const joinersPercentage = Math.round(
      (creators / (creators + joiners)) * 100,
    );
    return (
      <div className="funnelContainer">
        {this.renderPie(maxWidth, '#daf4d9', newUsers, 'Subscribers', 100)}
        <div
          style={{backgroundColor: '#bcedbc', color: '#78d977'}}
          className="transitionBar">
          <div className="lostPercent">
            {100 + this.calculateDecrease(newUsers, joiners + creators)}%
          </div>
        </div>
        <div style={{position: 'relative'}}>
          <div
            style={{
              minHeight: ((joiners + creators) / newUsers) * maxWidth,
              minWidth: ((joiners + creators) / newUsers) * maxWidth,
              '--size': ((joiners + creators) / newUsers) * maxWidth,
            }}
            className="pie">
            <div
              style={{
                '--offset': 0,
                '--value': joinersPercentage,
                '--over50': joinersPercentage > 50 ? 1 : 0,
              }}
              className="pie_segment"
            />
            <div style={{zIndex: 2}}>
              {Math.round(((joiners + creators) / newUsers) * 100)}%
            </div>
          </div>
          {!!creators && (
            <div className="creators">
              {creators.toLocaleString()}
              <br />
              Creators
              <br />
              {Math.round((creators / (joiners + creators)) * 100)}%
            </div>
          )}
          <div className="joiners">
            {joiners.toLocaleString()}
            <br />
            Joiners
            <br />
            {Math.round((joiners / (joiners + creators)) * 100)}%
          </div>
        </div>
        <div
          style={{backgroundColor: '#78d977', color: '#78d977'}}
          className="transitionBar">
          <div className="lostPercent">
            {100 +
              this.calculateDecrease(joiners + creators, usersWhoWentMercato)}
            %
          </div>
        </div>
        {this.renderPie(
          (usersWhoWentMercato / newUsers) * maxWidth,
          '#70d76f',
          usersWhoWentMercato,
          'In Mercato',
          Math.round((usersWhoWentMercato / newUsers) * 100),
        )}
        <div
          style={{backgroundColor: '#43b840', color: '#43b840'}}
          className="transitionBar">
          <div className="lostPercent">
            {100 +
              this.calculateDecrease(usersWhoWentMercato, usersWhoWentLive)}
            %
          </div>
        </div>
        {this.renderPie(
          (usersWhoWentLive / newUsers) * maxWidth,
          '#3ccb3b',
          usersWhoWentLive,
          'Live',
          Math.round((usersWhoWentLive / newUsers) * 100),
        )}
        <div
          style={{backgroundColor: '#6bc66a', color: '#6bc66a'}}
          className="transitionBar">
          <div className="lostPercent">
            {100 +
              this.calculateDecrease(usersWhoWentLive, usersWhoWentPaidLive)}
            %
          </div>
        </div>
        {this.renderPie(
          (usersWhoWentPaidLive / newUsers) * maxWidth,
          '#3ccb3b',
          usersWhoWentPaidLive,
          'Live Expert',
          Math.round((usersWhoWentPaidLive / newUsers) * 100),
        )}
      </div>
    );
  }

  render() {
    const {end, start, lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="new-users-funnel">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-user-circle-o" /> New Users Funnel (entre le{' '}
              {this.state.start} et le {this.state.end})
            </h3>
            <br />
          </div>
          <div className="box-body">
            <div className="margin-bottom text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <DateRangePickerWrapper
                  initialStartDate={moment(start)}
                  initialEndDate={moment(end)}
                  minimumNights={0}
                  onDatesChange={({startDate, endDate}) => {
                    this.setState({
                      start: moment(startDate).format('YYYY-MM-DD'),
                      end: moment(endDate).format('YYYY-MM-DD'),
                    });
                  }}
                />
                <button
                  className="btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
            {this.renderTable()}
          </div>
          {isFetching && <Loader />}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.newUsersFunnel,
  dispatch => ({dispatch}),
)(NewUsersFunnelWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/NewUsersFunnel/index.js